import image1 from '../../assets/bike.jpg'



export const info = [
    
    'Hi, my name is Jomar Cardoza I am a passionate creator that enjoys audio engineering and production.',

    'With the enviorment and workflow presented to me by the world of audio, the transition into programming felt seamless.',

    'Both, give me the freedom to create, learn, and produce what comes to mind.'

    

]

export const info2 = [
    
    <img src={image1} alt='picture of macbook' className='image-carasouel' />,

    // 'With the enviorment and workflow presented to me by the world of audio, the transition into programming felt seamless.',

    // 'Both, give me the freedom to create, learn, and produce what comes to mind.'


]



